export const uplodFormDefaultValues = {
  file: null,
  card_type: undefined,
  date_start: null,
  date_end: null,
  company_code: "",
  additional_info: "",
};
